import { call, put, takeLatest } from 'redux-saga/effects';

import { UPDATE_REFERRER_SETTINGS, FETCH_REFERRER_SETTINGS } from './constants';
import {
	updateSettingsSuccess,
	updateSettingsError,
	fetchSettingsSuccess,
	fetchSettingsError,
} from './actions';
import { updateReferrerSettingsApi, fetchReferrerSettingsApi } from './api';

export function* updateSettingsSaga(action) {
	try {
		const response = yield call(updateReferrerSettingsApi, action.settings);
		yield put(updateSettingsSuccess(response.data.data));
	} catch (err) {
		yield put(updateSettingsError(err));
	}
}

export function* fetchSettingsSaga() {
	try {
		const response = yield call(fetchReferrerSettingsApi);
		yield put(fetchSettingsSuccess(response.data.data));
	} catch (err) {
		yield put(fetchSettingsError(err));
	}
}

export default function* referrerSettingsSaga() {
	yield takeLatest(UPDATE_REFERRER_SETTINGS, updateSettingsSaga);
	yield takeLatest(FETCH_REFERRER_SETTINGS, fetchSettingsSaga);
}
